import { assembleLines } from './lines.js';
import { buildKeepFilter, keepLinePageLocal } from './strip.js';
import { linesToBlocks } from './paragraphs.js';
/** Below this many visible characters a PDF counts as having no text layer
 * (scanned/image-only — prototype threshold, PRD §8.4 message). */
export const PDF_NO_TEXT_LAYER_MIN_CHARS = 20;
export function pdfPagesHaveTextLayer(pages) {
    let chars = 0;
    for (const items of pages) {
        for (const item of items) {
            chars += item.str.trim().length;
            if (chars >= PDF_NO_TEXT_LAYER_MIN_CHARS)
                return true;
        }
    }
    return false;
}
/**
 * PRD §8.4 Tier A, whole document: the spec-exact reference used by golden
 * tests and by `finish()` of the progressive stream. `pages` is the full
 * document — the ≥60% header/footer statistic is defined over all pages.
 */
export function pdfItemsToBlocks(pages) {
    const pageLines = pages.map((items, page) => assembleLines(items, page));
    return blocksFromPageLines(pageLines);
}
function blocksFromPageLines(pageLines) {
    const keep = buildKeepFilter(pageLines);
    const kept = [];
    for (const lines of pageLines)
        for (const line of lines)
            if (keep(line))
                kept.push(line);
    return linesToBlocks(kept);
}
export function createPdfBlockStream(options) {
    const pageLines = [];
    let finished = false;
    return {
        feedPage(items) {
            if (finished)
                throw new Error('feedPage() after finish()');
            if (pageLines.length >= options.pageCount) {
                throw new Error(`feedPage() beyond declared pageCount ${options.pageCount}`);
            }
            const lines = assembleLines(items, pageLines.length);
            pageLines.push(lines);
            if (options.onPage !== undefined) {
                const kept = [];
                for (const page of pageLines) {
                    for (const line of page)
                        if (keepLinePageLocal(line, page))
                            kept.push(line);
                }
                options.onPage(pageLines.length - 1, linesToBlocks(kept));
            }
        },
        finish() {
            finished = true;
            return blocksFromPageLines(pageLines);
        },
    };
}
//# sourceMappingURL=pipeline.js.map